// ─────────────────────────────────────────────────────────────────────────────
// deltaParked.ts — THE PARKED COMPANIES WAITING ON THE OWNER, AND BRING BACK.
//
// Owner ruling 2026-09-29. The list rides the board (`parked_companies`, composed by
// `core/delta_board.parked_rows`); Bring back is the EXISTING unpark —
// `POST /api/delta/loop {action: "unpark", company_id}` — a write of `unparked_at`,
// never a deletion, so what snagged stays readable.
// ─────────────────────────────────────────────────────────────────────────────

import { apiBase, authToken } from './apiBase';

export const DELTA_LOOP_PATH = '/delta/loop';

export interface ParkedCompany {
  companyId: string;
  company: string;
  snag: string;
  /** 'NO' — something upstream must change first; 'YES' — running it again could work. */
  retryable: 'YES' | 'NO' | null;
  stageReached: string | null;
  parkedAt: string | null;
}

/** The board slot, or UNREAD. A row with no company is not a park. */
export function normalizeParked(slot: any): { phase: 'unread' | 'read'; rows: ParkedCompany[] } {
  if (!slot || !Array.isArray(slot.rows)) return { phase: 'unread', rows: [] };
  const rows = slot.rows
    .filter((r: any) => r && typeof r.company_id === 'string' && r.company_id)
    .map((r: any): ParkedCompany => ({
      companyId: r.company_id,
      company: typeof r.Company === 'string' && r.Company ? r.Company : r.company_id,
      snag: typeof r.snag === 'string' && r.snag ? r.snag : 'parked',
      retryable: r.retryable === 'YES' || r.retryable === 'NO' ? r.retryable : null,
      stageReached: typeof r.stage_reached === 'string' ? r.stage_reached : null,
      parkedAt: typeof r.parked_at === 'string' ? r.parked_at : null,
    }));
  return { phase: 'read', rows };
}

export async function unparkCompany(companyId: string): Promise<{ ok: boolean; refused: string | null }> {
  let res: Response;
  try {
    res = await fetch(apiBase() + DELTA_LOOP_PATH, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + authToken() },
      body: JSON.stringify({ action: 'unpark', company_id: companyId }),
    });
  } catch {
    return { ok: false, refused: 'not sent' };
  }
  let body: any = null;
  try { body = await res.json(); } catch { body = null; }
  if (!res.ok || !body || body.success !== true) {
    const detail = body && body.receipt && typeof body.receipt.detail === 'string' ? body.receipt.detail
      : body && typeof body.error === 'string' ? body.error : 'refused';
    return { ok: false, refused: detail };
  }
  return { ok: true, refused: null };
}
